"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DEFAULT_OVERRIDES () {
        return DEFAULT_OVERRIDES;
    },
    get formatParcelCurrency () {
        return formatParcelCurrency;
    },
    get getValueForParcelFieldNameOverride () {
        return getValueForParcelFieldNameOverride;
    },
    get parcelFieldNameOverridesByKey () {
        return parcelFieldNameOverridesByKey;
    }
});
const _lodash = require("lodash");
const _strings = require("common/utils/strings");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const formatCurrencyKeys = [
    "improvementValue",
    "landValue",
    "parcelValue"
];
const formatParcelCurrency = ({ key, value })=>{
    return formatCurrencyKeys.includes(key) ? (0, _strings.formatCurrency)(value) : value;
};
const DEFAULT_OVERRIDES = {
    parcelId: {
        name: "parcelId",
        value: "Parcel ID",
        isPublic: true
    },
    block: {
        name: "block",
        value: "Block",
        isPublic: true
    },
    lot: {
        name: "lot",
        value: "Lot",
        isPublic: true
    },
    yearBuilt: {
        name: "yearBuilt",
        value: "Structure year built",
        isPublic: true
    },
    improvementValue: {
        name: "improvementValue",
        value: "Improvement value",
        isPublic: true
    },
    landValue: {
        name: "landValue",
        value: "Land value",
        isPublic: true
    },
    parcelValue: {
        name: "parcelValue",
        value: "Parcel value",
        isPublic: true
    },
    buildingDescription: {
        name: "buildingDescription",
        value: "Building description",
        isPublic: true
    },
    owner: {
        name: "ownerName",
        value: "Owner name",
        isPublic: false
    },
    mailingAddress1: {
        name: "mailingAddress1",
        value: "Mailing address 1",
        isPublic: false
    },
    mailingAddress2: {
        name: "mailingAddress2",
        value: "Mailing address 2",
        isPublic: false
    }
};
const parcelFieldNameOverridesByKey = ({ parcelFieldNameOverrides, // @ts-ignore
defaults = DEFAULT_OVERRIDES, keyFn = (fieldNameOverride)=>{
    return fieldNameOverride.name;
} })=>{
    var _ref;
    return (_ref = parcelFieldNameOverrides === null || parcelFieldNameOverrides === void 0 ? void 0 : parcelFieldNameOverrides.reduce((obj, fieldNameOverride)=>{
        if (!fieldNameOverride) return obj;
        const key = keyFn(fieldNameOverride);
        return _object_spread_props(_object_spread({}, obj), {
            [key]: {
                name: fieldNameOverride.name,
                value: fieldNameOverride.value,
                isPublic: fieldNameOverride.isPublic || false
            }
        });
    }, (0, _lodash.cloneDeep)(defaults))) !== null && _ref !== void 0 ? _ref : defaults;
};
const getValueForParcelFieldNameOverride = ({ overrides, name })=>{
    var _overrides_find;
    return (overrides === null || overrides === void 0 ? void 0 : (_overrides_find = overrides.find((override)=>(override === null || override === void 0 ? void 0 : override.name) === name)) === null || _overrides_find === void 0 ? void 0 : _overrides_find.value) || DEFAULT_OVERRIDES[name].value;
};

//# sourceMappingURL=data:application/json;base64,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